/**
 * Colonia por CP — opcional, nunca bloquea el checkout (sesión 158).
 *
 * Archivo Navi-owned, fuera de theme.js a propósito (ADR-009: nunca editar
 * un archivo vendor-owned a mano). Consulta assets/cp-colonia-XX.json
 * (catálogo SEPOMEX, generado por tools/build_cp_colonias.py) para, al
 * capturar un CP de 5 dígitos: mostrar municipio/ciudad/estado, intentar
 * preseleccionar el Estado del selector nativo del shipping calculator, y
 * ofrecer un dropdown de colonias válidas para ese CP. Si el cliente elige
 * una, se guarda como atributo del carrito vía /cart/update.js — visible en
 * el pedido en Admin. Si no elige ninguna, no pasa nada: no es obligatorio.
 */
(function () {
	"use strict";

	function debounce(fn, wait) {
		var timer;
		return function () {
			var args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
				fn.apply(null, args);
			}, wait);
		};
	}

	function initForm(form) {
		var zipInput = form.querySelector("[data-cp-colonia-zip]");
		var select = form.querySelector("[data-cp-colonia-select]");
		var wrap = form.querySelector("[data-cp-colonia-wrap]");
		var cityText = form.querySelector("[data-cp-colonia-city]");
		var provinceSelect = form.querySelector('select[name="address[province]"]');
		var urlsScript = form.querySelector("[data-cp-colonia-urls]");
		var cartUpdateUrl = form.getAttribute("data-cart-update-url");

		if (!zipInput || !select || !wrap || !urlsScript) return;

		var bucketUrls;
		try {
			bucketUrls = JSON.parse(urlsScript.textContent);
		} catch (e) {
			return;
		}

		var bucketCache = {};

		function fetchBucket(prefix) {
			if (bucketCache[prefix]) return bucketCache[prefix];
			var url = bucketUrls[prefix];
			if (!url) {
				bucketCache[prefix] = Promise.resolve({});
				return bucketCache[prefix];
			}
			bucketCache[prefix] = fetch(url)
				.then(function (res) {
					if (!res.ok) throw new Error("bucket not found: " + prefix);
					return res.json();
				})
				.catch(function () {
					return {};
				});
			return bucketCache[prefix];
		}

		function resetColonia() {
			select.innerHTML = "";
			select.disabled = true;
			wrap.hidden = true;
			if (cityText) {
				cityText.hidden = true;
				cityText.textContent = "";
			}
		}

		function applyEntry(entry) {
			if (cityText) {
				var place = entry.municipio;
				if (entry.ciudad && entry.ciudad !== entry.municipio) {
					place += " — " + entry.ciudad;
				}
				cityText.textContent = place + ", " + entry.estado;
				cityText.hidden = false;
			}

			if (provinceSelect && entry.estado) {
				var match = Array.prototype.find.call(provinceSelect.options, function (opt) {
					return opt.text.trim() === entry.estado;
				});
				if (match && provinceSelect.value !== match.value) {
					provinceSelect.value = match.value;
					provinceSelect.dispatchEvent(new Event("change", { bubbles: true }));
				}
			}

			if (!entry.colonias || !entry.colonias.length) return;

			var placeholder = document.createElement("option");
			placeholder.value = "";
			placeholder.textContent = "Selecciona tu colonia (opcional)";
			select.appendChild(placeholder);

			entry.colonias.forEach(function (colonia) {
				var opt = document.createElement("option");
				opt.value = colonia[0];
				opt.textContent = colonia[0];
				select.appendChild(opt);
			});

			select.disabled = false;
			wrap.hidden = false;
		}

		var handleZip = debounce(function () {
			var cp = zipInput.value.trim();
			resetColonia();
			if (!/^\d{5}$/.test(cp)) return;

			fetchBucket(cp.slice(0, 2)).then(function (bucket) {
				var entry = bucket[cp];
				if (entry) applyEntry(entry);
			});
		}, 300);

		zipInput.addEventListener("input", handleZip);
		zipInput.addEventListener("blur", handleZip);
		if (zipInput.value) handleZip();

		select.addEventListener("change", function () {
			if (!select.value || !cartUpdateUrl) return;
			fetch(cartUpdateUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ attributes: { Colonia: select.value } }),
			}).catch(function () {
				/* best-effort: si falla, el cliente igual puede seguir al checkout */
			});
		});
	}

	document.querySelectorAll("[data-cp-colonia-form]").forEach(initForm);
})();
